export default __webpack_public_path__ + "static/media/v.144ea14a.svg";